import React, { useState } from "react";
import { Badge } from 'react-bootstrap';

const SemanticComponent = ({ data }) => {
    const [isOpen, setIsOpen] = useState({});

    const toggleAccordion = (key) => {
        setIsOpen(prevState => ({ ...prevState, [key]: !prevState[key] }));
    };

    const semantiqueGlobale = data?.semantiqueGlobale;

    if (!semantiqueGlobale || typeof semantiqueGlobale !== 'object') {
        return (
            <div className="alert alert-warning mb-0" role="status">
                Analyse sémantique indisponible pour cette page.
            </div>
        );
    }

    const profil = semantiqueGlobale?.profil_lecture_detecte || null;
    const criteres = semantiqueGlobale?.criteres || {};
    const thematiques = semantiqueGlobale?.thematiques || { nom: 'Thématiques UniCA', donnees: {} };

    return (

        <div>

            <div className="alert alert-light d-flex align-items-baseline mb-2">
                <strong className="me-2">Profil type de lecteur détecté : </strong>
                {profil ? (
                    <>
                        {profil.nom}
                        {typeof profil.niveau !== 'undefined' && profil.niveau !== null && (
                            <> (complexité {profil.niveau} sur 3)</>
                        )}
                    </>
                ) : (
                    <span>Profil de lecture non détecté</span>
                )}
            </div>

            <div className="accordion mb-2">

                {Object.keys(criteres).length === 0 ? (
                    <div className="accordion-item border-top-0">
                        <div className="accordion-body">Aucun critère disponible.</div>
                    </div>
                ) : (
                    Object.entries(criteres).map(([key, critere]) => (

                        <div className="accordion-item border-top-0" key={key}>
                            <h2 className="accordion-header" id={`heading-${key}`}>
                                <button
                                    className={`accordion-button ${isOpen[key] ? '' : 'collapsed'}`}
                                    onClick={() => toggleAccordion(key)}
                                    aria-expanded={isOpen[key]}
                                    aria-controls={`collapse-${key}`}>

                                    <span className={`${critere.donnees.seuil_categorie === 'acceptable' ? 'text-success' : 'text-warning'} me-1`}>
                                        {critere.donnees.seuil_categorie === 'acceptable' ? <i className="bi bi-check-circle-fill"></i> : <i className="bi bi-exclamation-circle-fill"></i>}
                                    </span>
                                    <span>{critere.nom}</span>
                                </button>
                            </h2>
                            <div id={`collapse-${key}`}
                                className={`accordion-collapse collapse ${isOpen[key] ? 'show' : ''}`}
                                aria-labelledby={`heading-${key}`}>
                                <div className="accordion-body">

                                    <div className="mb-2">{critere.donnees.seuils.explications[critere.donnees.seuil_categorie]}</div>

                                    <div className="progress-stacked rounded-0 position-relative">
                                        <div className="progress" style={{ width: (critere.donnees.seuils.valeurs.min * 100) + '%' }}>
                                            <div className="progress-bar bg-warning text-end px-1">{critere.donnees.seuils.valeurs.min}</div>
                                        </div>
                                        <div className="progress" style={{ width: ((critere.donnees.seuils.valeurs.max - critere.donnees.seuils.valeurs.min) * 100) + '%' }}>
                                            <div className="progress-bar bg-success"></div>
                                        </div>
                                        <div className="progress" style={{ width: (100 - critere.donnees.seuils.valeurs.max * 100) + '%' }}>
                                            <div className="progress-bar bg-warning text-start px-1">{critere.donnees.seuils.valeurs.max}</div>
                                        </div>
                                        <div className="progress-current" style={{ left: (critere.donnees.score * 100) + '%' }}></div>
                                    </div>

                                    <div className="d-flex lh-1">
                                        <div style={{ width: (critere.donnees.seuils.valeurs.min * 100) + '%' }}>
                                            <div className="border-end"><small><em>{critere.donnees.seuils.explications['faible']}</em></small></div>
                                        </div>
                                        <div style={{ width: ((critere.donnees.seuils.valeurs.max - critere.donnees.seuils.valeurs.min) * 100) + '%' }}>
                                            <div className="border-end"><small><em>{critere.donnees.seuils.explications['acceptable']}</em></small></div>
                                        </div>
                                        <div style={{ width: (100 - critere.donnees.seuils.valeurs.max * 100) + '%' }}>
                                            <div><small><em>{critere.donnees.seuils.explications['élevé']}</em></small></div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                    ))
                )}
            </div>

            <div className="accordion">
                <div className="accordion-item border-top-0" key='thematiques'>
                    <h2 className="accordion-header" id={`heading-thematiques`}>
                        <button
                            className={`accordion-button ${isOpen['thematiques'] ? '' : 'collapsed'}`}
                            onClick={() => toggleAccordion('thematiques')}
                            aria-expanded={isOpen['thematiques']}
                            aria-controls={`collapse-thematiques`}>

                            <i className="bi bi-info-circle-fill text-primary me-1"></i>
                            <span>{thematiques?.nom || 'Thématiques'}</span>
                            <Badge bg="info" className="ms-2">Bêta</Badge>
                        </button>
                    </h2>
                    <div id={`collapse-thematiques`}
                        className={`accordion-collapse collapse ${isOpen['thematiques'] ? 'show' : ''}`}
                        aria-labelledby={`heading-thematiques`}>
                        <div className="accordion-body p-0">

                            <table className="table">
                                <thead className="table-light">
                                    <tr>
                                        <th><small>Thématiques UniCA</small></th>
                                        <th><small>Mots clés détectés dans votre texte</small></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {thematiques && thematiques.donnees ? (
                                        Object.entries(thematiques.donnees).map(([key, thematique]) => (
                                            <tr key={key}>
                                                <th><small>{key}</small></th>
                                                <td>
                                                    <small>
                                                        {(thematique?.details_calcul?.termes_matches || []).join(' • ') || '—'}
                                                    </small>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2"><small>Aucune thématique détectée.</small></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>


            </div>

        </div>


    );
}

export default SemanticComponent;
